import { render, staticRenderFns } from "./RequestProductCreateDialog.vue?vue&type=template&id=5b784460"
import script from "./RequestProductCreateDialog.vue?vue&type=script&lang=js"
export * from "./RequestProductCreateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports